import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { TruckIcon, PackageIcon, CreditCardIcon, ClockIcon, MapPinIcon, CheckIcon } from 'lucide-react';
export function DeliveryPage() {
  const deliveryMethods = [{
    icon: TruckIcon,
    title: 'Нова Пошта',
    description: 'Доставка у відділення або поштомат',
    time: '1-3 дні',
    price: 'від 50 ₴',
    freeFrom: 'Безкоштовно від 5000 ₴'
  }, {
    icon: PackageIcon,
    title: "Кур'єр Нової Пошти",
    description: 'Доставка за вашою адресою',
    time: '1-3 дні',
    price: 'від 100 ₴',
    freeFrom: null
  }];
  const paymentMethods = [{
    icon: CreditCardIcon,
    title: 'Оплата карткою онлайн',
    description: 'Visa, Mastercard — безпечна оплата через LiqPay'
  }, {
    icon: PackageIcon,
    title: 'Післяплата',
    description: 'Оплата при отриманні у відділенні Нової Пошти'
  }, {
    icon: CreditCardIcon,
    title: 'Безготівковий розрахунок',
    description: 'Для юридичних осіб та ФОП'
  }];
  const regions = ['Київська область', 'Львівська область', 'Івано-Франківська область', 'Одеська область', 'Харківська область', 'Дніпропетровська область', 'Запорізька область', 'Вінницька область'];
  return <main className="min-h-screen bg-slate-50" data-id="element-732">
      {/* Breadcrumbs */}
      <div className="bg-white border-b border-slate-100" data-id="element-733">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-734">
          <nav className="flex items-center gap-2 text-sm" data-id="element-735">
            <Link to="/" className="text-slate-500 hover:text-slate-700" data-id="element-736">
              Головна
            </Link>
            <span className="text-slate-300" data-id="element-737">/</span>
            <span className="text-slate-900 font-medium" data-id="element-738">
              Доставка та оплата
            </span>
          </nav>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-739">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-740">
          <h1 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-741">
            Доставка та оплата
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-742">
            Доставляємо по всій Україні. Відправляємо замовлення в день
            оформлення.
          </p>
        </div>

        {/* Delivery Methods */}
        <section className="mb-16" data-id="element-743">
          <h2 className="text-2xl font-bold text-slate-900 mb-8" data-id="element-744">
            Способи доставки
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-745">
            {deliveryMethods.map((method, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-2xl shadow-md p-6" data-id="element-746">
                <div className="flex items-start gap-4" data-id="element-747">
                  <div className="w-12 h-12 bg-sky-100 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-748">
                    <method.icon className="w-6 h-6 text-sky-600" data-id="element-749" />
                  </div>
                  <div className="flex-1" data-id="element-750">
                    <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-751">
                      {method.title}
                    </h3>
                    <p className="text-slate-600 mb-4" data-id="element-752">{method.description}</p>
                    <div className="flex flex-wrap gap-4 text-sm" data-id="element-753">
                      <div className="flex items-center gap-2" data-id="element-754">
                        <ClockIcon className="w-4 h-4 text-slate-400" data-id="element-755" />
                        <span className="text-slate-600" data-id="element-756">{method.time}</span>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-757">
                        <CreditCardIcon className="w-4 h-4 text-slate-400" data-id="element-758" />
                        <span className="text-slate-600" data-id="element-759">{method.price}</span>
                      </div>
                    </div>
                    {method.freeFrom && <div className="mt-3 inline-flex items-center gap-2 px-3 py-1.5 bg-emerald-50 text-emerald-700 rounded-lg text-sm font-medium" data-id="element-760">
                        <CheckIcon className="w-4 h-4" data-id="element-761" />
                        {method.freeFrom}
                      </div>}
                  </div>
                </div>
              </motion.div>)}
          </div>
        </section>

        {/* Payment Methods */}
        <section className="mb-16" data-id="element-762">
          <h2 className="text-2xl font-bold text-slate-900 mb-8" data-id="element-763">
            Способи оплати
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-764">
            {paymentMethods.map((method, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-2xl shadow-md p-6" data-id="element-765">
                <div className="w-12 h-12 bg-sky-100 rounded-xl flex items-center justify-center mb-4" data-id="element-766">
                  <method.icon className="w-6 h-6 text-sky-600" data-id="element-767" />
                </div>
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-768">
                  {method.title}
                </h3>
                <p className="text-slate-600" data-id="element-769">{method.description}</p>
              </motion.div>)}
          </div>
        </section>

        {/* Delivery Regions */}
        <section className="mb-16" data-id="element-770">
          <h2 className="text-2xl font-bold text-slate-900 mb-8" data-id="element-771">
            Регіони доставки
          </h2>
          <div className="bg-white rounded-2xl shadow-md p-6" data-id="element-772">
            <div className="flex items-start gap-4 mb-6" data-id="element-773">
              <div className="w-12 h-12 bg-sky-100 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-774">
                <MapPinIcon className="w-6 h-6 text-sky-600" data-id="element-775" />
              </div>
              <div data-id="element-776">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-777">
                  Доставка по всій Україні
                </h3>
                <p className="text-slate-600" data-id="element-778">
                  Відправляємо замовлення у всі населені пункти, де є відділення
                  Нової Пошти
                </p>
              </div>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-id="element-779">
              {regions.map((region, index) => <div key={index} className="flex items-center gap-2 text-sm text-slate-600" data-id="element-780">
                  <CheckIcon className="w-4 h-4 text-emerald-500" data-id="element-781" />
                  {region}
                </div>)}
              <div className="flex items-center gap-2 text-sm text-sky-600 font-medium" data-id="element-782">
                <CheckIcon className="w-4 h-4" data-id="element-783" />
                та інші регіони
              </div>
            </div>
          </div>
        </section>

        {/* Important Info */}
        <section data-id="element-784">
          <h2 className="text-2xl font-bold text-slate-900 mb-8" data-id="element-785">
            Важлива інформація
          </h2>
          <div className="bg-sky-50 rounded-2xl p-6" data-id="element-786">
            <ul className="space-y-4" data-id="element-787">
              <li className="flex items-start gap-3" data-id="element-788">
                <CheckIcon className="w-5 h-5 text-sky-600 flex-shrink-0 mt-0.5" data-id="element-789" />
                <span className="text-slate-700" data-id="element-790">
                  Замовлення, оформлені до 14:00, відправляємо того ж дня
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-791">
                <CheckIcon className="w-5 h-5 text-sky-600 flex-shrink-0 mt-0.5" data-id="element-792" />
                <span className="text-slate-700" data-id="element-793">
                  Після відправлення ви отримаєте SMS з номером ТТН для
                  відстеження
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-794">
                <CheckIcon className="w-5 h-5 text-sky-600 flex-shrink-0 mt-0.5" data-id="element-795" />
                <span className="text-slate-700" data-id="element-796">
                  Великогабаритні товари (басейни, обладнання) доставляємо
                  вантажним відділенням
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-797">
                <CheckIcon className="w-5 h-5 text-sky-600 flex-shrink-0 mt-0.5" data-id="element-798" />
                <span className="text-slate-700" data-id="element-799">
                  При отриманні перевірте цілісність упаковки та комплектацію
                </span>
              </li>
            </ul>
          </div>
        </section>
      </div>
    </main>;
}